import baseApi from "../../../common/api/baseApi";

const authHeaders = () => ({
  headers: { token: localStorage.getItem("token") }
});

export const searchAllUsersApi = () => {
  return baseApi
    .post("/member/searchAllUsers", {}, authHeaders())
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const approvalUserApi = ({ mbrId, status }) => {
  return baseApi
    .post(
      "/member/approvalUser",
      { mbrId: mbrId, status: status },
      authHeaders()
    )
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const updateUseYnApi = ({ mbrId, useYn }) => {
  return baseApi
    .post(
      "/member/updateUseYn",
      { mbrId: mbrId, useYn: useYn },
      authHeaders()
    )
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const deleteUserApi = ({ mbrId }) => {
  return baseApi
    .post("/member/deleteUser", { mbrId: mbrId }, authHeaders())
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
